/**
 * strap-state.js — single source of truth + pure reducer/normalize/validate (prototype).
 */
(function (SB) {
  'use strict';
  var M = function () { return SB.MANIFEST; };

  SB.selectors = {
    leather: function (s) { return M().leathers.find(function (l) { return l.id === s.leatherId; }) || M().leathers[0]; },
    color: function (s) { var l = SB.selectors.leather(s); return l.colors.find(function (c) { return c.id === s.colorId; }) || l.colors[0]; },
    styleDef: function (s) { return M().styles.find(function (x) { return x.id === s.style; }) || M().styles[0]; }
  };

  SB.createInitialState = function () {
    return {
      leatherId: 'epsom', colorId: 'navy',
      style: 'classic',
      stitchColor: 'cream',
      edgeMode: 'match', edgeColor: 'black',   // match = base edge (tone-on-tone); custom = overlay
      keeperMode: 'match', keeperColor: 'tan',  // match = base keeper; custom = overlay
      underlayColor: 'white',                   // only for racing; defaults to white on entering racing
      buckleId: 'silver',
      profile: 'Flat', lugWidth: 20,
      note: ''
    };
  };

  SB.strapReducer = function (state, action) {
    if (action.type === 'SET') {
      var n = Object.assign({}, state); n[action.field] = action.value;
      // Racing (needs underlay) starts on white every time it's entered, per owner's request.
      if (action.field === 'style') {
        var sd = M().styles.find(function (x) { return x.id === action.value; }) || M().styles[0];
        if (sd.needsUnderlay) n.underlayColor = 'white';
      }
      return n;
    }
    if (action.type === 'RESET') return SB.createInitialState();
    return state;
  };

  SB.normalizeState = function (state) {
    var s = Object.assign({}, state);
    // Colour must belong to the selected leather; on a leather switch fall back to its first colour.
    var lea = SB.selectors.leather(s);
    var okColor = lea.colors.some(function (c) { return c.id === s.colorId; });
    if (!okColor) s.colorId = lea.colors[0].id;
    // Leathers without custom keeper/edge layers stay tone-on-tone.
    if (lea.keeperCustom === false) s.keeperMode = 'match';
    if (lea.edgeCustom === false) s.edgeMode = 'match';
    var st = SB.selectors.styleDef(s);
    if (!st.needsUnderlay) s.underlayColor = null;        // clear so it never leaks to cart
    if (s.edgeMode !== 'custom') s.edgeColor = null;
    if (s.keeperMode !== 'custom') s.keeperColor = null;
    return s;
  };

  SB.validateState = function (state) {
    var errors = [];
    if (SB.selectors.styleDef(state).needsUnderlay && !state.underlayColor)
      errors.push({ field: 'underlayColor', msg: 'Choose an underlay colour.' });
    return { ok: errors.length === 0, errors: errors };
  };
})(window.StrapBuilder = window.StrapBuilder || {});
